import { createFileRoute } from "@tanstack/react-router";
import { GuidesIndexPage } from "@/components/guides/GuidesIndexPage";
import { guidesIndexSeo } from "@/lib/page-seo";

export const Route = createFileRoute("/guides/")({
  loader: ({ location }) => ({ href: location.href }),
  head: ({ loaderData }) => guidesIndexSeo(loaderData?.href ?? "/guides"),
  component: GuidesIndexPage,
});
